module.exports = __webpack_public_path__ + "static/Fei-Fei_Liu_headshot_lores-09f2595c27974b4b49e7af822e62a4e1.png";